import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import ManualFile from '../../components/manualFile/index.js'


const HomeManualFile = () => {

    return (
        <div>
            <Header />

            <ManualFile />

            <Footer />
        </div>
    );
}

export default HomeManualFile;
